import styled from 'styled-components'

export const StyledSvgAnimation = styled.g`
  animation: ${({ theme }) => theme.animation.appearAnimation} 1s linear;
`
